module.exports = __webpack_public_path__ + "06_long_black.3ca168b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/06_long_black.png
// module id = pW+D
// module chunks = 0